import { defaultFirebaseAuth } from 'config/firebase-config';
import { signOut } from 'firebase/auth';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { IAppReducer } from 'models/reducer.interface';
import {
  setSignOut,
  setUser,
  updateUserAction,
} from 'pages/sing-in/store/actions/auth.types';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPlanByCompanyId } from 'shared/services/plans';
import { removeVehicleDataFromLocalStorage } from 'shared/services/user-add-subscription';
import { setBranch } from 'store/actions/branch.types';
import { isSodaOrigin } from 'utils/soda-origin.utils';
interface CustomizedState {
  infoPopUp: {
    showPopUp: boolean;
    email: string;
    name: string;
  };
}

export const useSettingsOptions = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: IAppReducer) => state.authReducer);
  const location = useLocation();
  const navigate = useNavigate();
  const { infoPopUp } = (location.state as CustomizedState) || {};
  const [popUp, setPopUp] = useState(false);
  const [, copy] = useCopyToClipboard();

  const isSodaRedirectActive =
    process.env.REACT_APP_ENABLE_SODA_REDIRECT === 'true' &&
    Boolean(user.agentAuthData?.returnUrl) &&
    isSodaOrigin(user.agentAuthData?.returnUrl ?? '');

  useEffect(() => {
    if (!isSodaRedirectActive) return;
    sessionStorage.removeItem('state');
    signOut(defaultFirebaseAuth)
      .then(() => {
        globalThis.location.href = user.agentAuthData!.returnUrl!;
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    (async () => {
      if (!user.companyId) {
        return;
      }
      const response = await getPlanByCompanyId(user.companyId.toString());
      dispatch(
        updateUserAction({
          plansId: response.join(','),
        })
      );
    })();
  }, []);
  useLayoutEffect(() => {
    if (infoPopUp?.showPopUp) {
      sowPopUp();
    }
  }, [infoPopUp]);
  const sowPopUp = () => {
    setPopUp(true);
  };
  const hiddenPopUp = () => {
    setPopUp(false);
    navigate(location.pathname, {
      replace: true,
    });
  };
  const handleSignOut = async () => {
    try {
      if (user.agentAuthData?.accessToken) {
        if (user.agentAuthData?.returnUrl) {
          if (isSodaOrigin(user.agentAuthData.returnUrl)) {
            // Limpiar estado persistido sin despachar a Redux.
            // Un dispatch causaría re-render → AuthGuard ve uid vacío → flash de /login
            // antes de que window.location.href navegue a Soda.
            sessionStorage.removeItem('state');
            await signOut(defaultFirebaseAuth);
            window.location.href = user.agentAuthData.returnUrl;
            return;
          }
        }
        dispatch(setBranch(user.agentAuthData.branch));
        dispatch(
          setUser({
            userId: user.agentAuthData.userId,
            uid: user.agentAuthData.uid,
            name: user.agentAuthData.name,
            lastname: user.agentAuthData.lastname,
            email: user.agentAuthData.email,
            accessToken: user.agentAuthData.accessToken,
            userAuth: {
              phone: user.agentAuthData.userAuth.phone,
              phone_country_code:
                user.agentAuthData.userAuth.phone_country_code,
            },
            agentId: user.agentId,
            role: user.agentAuthData.role ?? null,
            countryAcronym: user.agentAuthData.countryAcronym,
            companyId: user.agentAuthData.companyId,
            plansId: user.agentAuthData.plansId,
            tknFirebase: user.agentAuthData.tknFirebase,
            isTester: user.agentAuthData.isTester,
            agentAuthData: {},
          })
        );
      } else {
        removeVehicleDataFromLocalStorage();
        signOut(defaultFirebaseAuth);
        dispatch(setSignOut());
      }
    } catch (error) {
      // TODO Manejar error
    }
  };
  const handleCopy = (text: string) => async () => {
    try {
      await copy(text);
    } catch (error) {
      console.error('Failed to copy!', error);
    }
  };

  return { handleSignOut, user, handleCopy, popUp, hiddenPopUp, isSodaRedirectActive };
};
